import IMAGES from "images";
import { ConditionName, ICommentSettingsPopoverProps, IComments } from "interfaces";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import { conditions, handleHasXTokenParamOrSendXToken, inViewPort, responseValidator } from "helpers";
import { useAppDispatch, useAppSelector } from "redux-share";
import { setComments } from "redux-share/slices/commentsSlice";
import useOnClickOutside from "helpers/hooks/useOnClickOutside";
import store from "redux-share/store";
import ConfirmationModal from "../../confirmationModal/confirmationModal";
import { API, apiCaller } from "services";
import { toast } from "mobin-toast";
import { shallowEqual } from "react-redux";

const CommentSettingsPopover = ({
    setShowPopover,
    isReply,
    replies,
    setReplies,
    commentId,
    setRepliesCount,
    touchPosition
}: ICommentSettingsPopoverProps) => {
    const { videoElementSizeInfo } = useAppSelector(({ videoData: { videoElementSizeInfo } }) => ({ videoElementSizeInfo }), shallowEqual);

    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [modalPosition, setModalPosition] = useState<{ x: number; y: number }>({
        x: touchPosition ? touchPosition.x : 0,
        y: touchPosition ? touchPosition.y : 0
    });

    const commentSettingRef = useRef<any>(null);

    useOnClickOutside(commentSettingRef, (event) => {
        if (!showDeleteModal) {
            event.stopPropagation();
            setShowPopover(false);
        }
    });

    const dispatch = useAppDispatch();

    const handleDeleteComment = async () => {
        const { status } = await apiCaller({
            url: API().comment.deleteComment(commentId),
            method: "DELETE",
            headers: handleHasXTokenParamOrSendXToken()
        });
        if (responseValidator(status)) {
            const { comments } = store.getState().comments;
            const filteredComments = comments!.filter((comment: IComments) => comment.id !== commentId);
            dispatch(setComments(filteredComments));
            toast({ title: "دیدگاه مورد نظر با موفقیت حذف شد.", type: "success" });
        } else {
            toast({ title: "حذف دیدگاه با مشکل مواجه شده است.", type: "error" });
        }
    };

    const handleDeleteReply = async () => {
        const { status } = await apiCaller({
            url: API().comment.deleteComment(commentId),
            method: "DELETE",
            headers: handleHasXTokenParamOrSendXToken()
        });
        if (responseValidator(status)) {
            const filteredReplies = replies!.filter((reply: IComments) => reply.id !== commentId);
            setReplies!(filteredReplies);
            setRepliesCount!(replies!.length - 1);
            toast({ title: "دیدگاه مورد نظر با موفقیت حذف شد.", type: "success" });
        } else {
            toast({ title: "حذف دیدگاه با مشکل مواجه شده است.", type: "error" });
        }
    };

    useEffect(() => {
        if (commentSettingRef) {
            const result = inViewPort(commentSettingRef.current);
            if (result === "OutViewPortFromLeft") setModalPosition({ x: 0, y: touchPosition?.y! - videoElementSizeInfo.bottom });
            else if (result === "OutViewPortFromRight")
                setModalPosition({ x: videoElementSizeInfo.right - 138, y: touchPosition?.y! - videoElementSizeInfo.bottom });
            else setModalPosition({ x: touchPosition?.x! - 65, y: touchPosition?.y! - videoElementSizeInfo.bottom });
        }
    }, [touchPosition]);

    return (
        <>
            <div
                style={{
                    boxShadow: conditions(ConditionName.isDarkMode) ? "5px 5px 15px 0px rgba(134, 151, 170, 0.08)" : "unset",
                    position: conditions(ConditionName.isTouchScreen) ? "fixed" : "absolute",
                    top: conditions(ConditionName.isTouchScreen) ? modalPosition.y : "100%",
                    left: conditions(ConditionName.isTouchScreen) ? modalPosition.x : 0
                }}
                className={`pl-z-[100000] pl-border dark:pl-border-none pl-border-secondary-300 pl-rounded-[8px] pl-bg-white dark:pl-bg-dark-1 pl-px-4 pl-py-2 pl-mt-2`}
                ref={commentSettingRef}
            >
                <button className="pl-flex pl-items-center pl-gap-6 pl-w-max pl-text-red-500" onClick={() => setShowDeleteModal(true)}>
                    <Image src={IMAGES.trashRed} width={16} height={16} />
                    <span className="pl-text-[14px] pl-font-medium">حذف دیدگاه</span>
                </button>
            </div>
            <ConfirmationModal
                status={!!showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onSubmit={() => (isReply ? handleDeleteReply() : handleDeleteComment())}
                modalType="DELETE"
                cancelButtonText="انصراف"
                submitButtonText="حذف"
                text="آیا از حذف دیدگاه مطمئن هستید؟"
            />
        </>
    );
};

export default CommentSettingsPopover;
